import { type TeamRankingResponseRelatedTeamRankingResponseRelatedPagedData } from '@on3/api';
import { removeZeroTies } from '@on3/api/utils/games';
import { Avatar } from '@on3/ui-lib/components/Avatar';
import { useSite } from '@on3/ui-lib/index';
import { createUrl } from '@on3/ui-lib/utils/url';
import { MasseyRatings } from '@public/components/UI/MasseyRatings/MasseyRatings';
import Link from 'next/link';

import styles from './TopRankings.module.scss';

interface TopRankingsProps {
  rankings: TeamRankingResponseRelatedTeamRankingResponseRelatedPagedData;
}

export const TopRankings = ({ rankings }: TopRankingsProps) => {
  const { sportsData } = useSite();
  const { relatedModel, list = [] } = rankings;
  const { sportKey = 1 } = relatedModel ?? {};

  const sport = sportsData.find((s) => s.key === sportKey);
  const sportName = sport?.name ?? 'Football';

  return (
    <div className={styles.block}>
      <h2>College {sportName} Rankings</h2>
      <MasseyRatings />
      <section className={styles.rankings}>
        {list.map((ranking) => (
          <Link
            className={styles.ranking}
            href={createUrl(['college', ranking.currentOrganization?.slug])}
            key={ranking.orgKey}
          >
            <div className={styles.rank}>{ranking.overallRank}</div>
            <div className={styles.team}>
              <figure>
                <Avatar
                  altText={`${ranking.currentOrganization?.name} ${ranking.currentOrganization?.mascot} Logo`}
                  domain={ranking.currentOrganization?.defaultAsset?.domain}
                  source={ranking.currentOrganization?.defaultAsset?.source}
                  teamAvatar
                  title={ranking.currentOrganization?.fullName}
                  type={ranking.currentOrganization?.defaultAsset?.type}
                />
              </figure>
              <div>
                <span className={styles.name}>
                  {ranking.currentOrganization?.knownAs ||
                    ranking.currentOrganization?.name}
                </span>
                <span>{`${ranking.currentOrganization?.mascot}`}</span>
              </div>
            </div>
            <div className={styles.rating}>
              <span>{ranking.overallScore?.toFixed(2)}</span>
              <span>{removeZeroTies(ranking.record)}</span>
            </div>
          </Link>
        ))}
      </section>

      <Link
        className={styles.viewAll}
        href={createUrl(['college', 'rankings', sportName])}
      >
        Complete Rankings
      </Link>
    </div>
  );
};
